export enum OnboardingStep {
    /**
     * Currently the actual starting point of onboarding.
     */
    POST_SIGN_UP,
    /**
     * Top menu is not blurred anymore. User is told about the options in the top menu.
     */
    SHOW_NAV,
    SHOW_NAV_LOGOUT,
    SHOW_PATIENT_SELECTION_VIEW,
    SHOW_PATIENT_SELECTION_VIEW_OTP,
    SHOW_PATIENT_SELECTION_VIEW_REQUESTS,
    SHOW_PATIENT_SELECTION_VIEW_PATIENTS,
    SHOW_PATIENT_OVERVIEW,
    SHOW_PATIENT_OVERVIEW_REPORT,
    SHOW_PATIENT_OVERVIEW_NOTES,
    SHOW_PATIENT_OVERVIEW_PHQ,
    SHOW_PATIENT_OVERVIEW_SFQ,
    SHOW_PATIENT_OVERVIEW_MOOD,
    SHOW_PATIENT_OVERVIEW_SLEEP,
    SHOW_PATIENT_OVERVIEW_CARDIAC,
    SHOW_PATIENT_OVERVIEW_STEPS,
    SHOW_PATIENT_OVERVIEW_MEDICATION,
    SHOW_PATIENT_MEDICATION,
    SHOW_PATIENT_DETAIL_VIEW_PHQ,
    SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
    SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
    SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT,
    SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE,
   // SHOW_PATIENT_DETAIL_VIEW_PHQ_SETTINGS,
    SHOW_PATIENT_END
}

export const OnboardingStepOrder: OnboardingStep[] = [
    OnboardingStep.POST_SIGN_UP,
    OnboardingStep.SHOW_NAV,
    OnboardingStep.SHOW_NAV_LOGOUT,
    OnboardingStep.SHOW_PATIENT_SELECTION_VIEW,
    OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_OTP,
    OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_REQUESTS,
    OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_PATIENTS,
    OnboardingStep.SHOW_PATIENT_OVERVIEW,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_CARDIAC,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_STEPS,
    OnboardingStep.SHOW_PATIENT_OVERVIEW_MEDICATION,
    OnboardingStep.SHOW_PATIENT_MEDICATION,
    OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
    OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
    OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
    OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT,
    OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE,
    //OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_SETTINGS,
    OnboardingStep.SHOW_PATIENT_END
]

export const OnboardingStepChapters: {
    chapter: string
    steps: OnboardingStep[]
}[] = [
    {
        chapter: "Startseite",
        steps: [
            OnboardingStep.POST_SIGN_UP,
            OnboardingStep.SHOW_NAV,
            OnboardingStep.SHOW_NAV_LOGOUT,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_OTP,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_REQUESTS,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_PATIENTS
        ]
    },
    {
        chapter: "Patienten-Übersicht",
        steps: [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_CARDIAC,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_STEPS,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MEDICATION
        ]
    },
    {
        chapter: "Medikationsansicht",
        steps: [
            OnboardingStep.SHOW_PATIENT_MEDICATION
        ]
    },
    {
        chapter: "Daten-Detail-Ansicht",
        steps: [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE,
            //OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_SETTINGS,
            OnboardingStep.SHOW_PATIENT_END
        ]
    }
]

export function onboardingStepIsOneOf(
    onboardingStep: OnboardingStep,
    steps: OnboardingStep[]
) {
    return steps.includes(onboardingStep)
}

export default OnboardingStep
